






























































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import {Mutation, State} from "vuex-class";

@Component({
    name: 'alzuhud-header'
})
export default class AlzuhudHeader extends Vue {
    @Prop({default: false}) light: boolean;
    @Mutation setLanguage: Function;
    @State language: any;
    menu: boolean = false;
    menu2: boolean = false;
    menu3: boolean = false;
    dialog: boolean = false;
    /**
     *
     */
    constructor() {
        super();
    }

    changePage(route: string) {
        this.$router.push(`/${route}`);
    }
}
